import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Stack,
  Text,
} from '@chakra-ui/react';
import React, { useRef } from 'react';

type ConfirmModelUpdateModalProps = {
  isOpen: boolean;
  onConfirm: () => Promise<void>;
  onClose: () => void;
};

export default function ConfirmModelUpdateModal({
  isOpen,
  onConfirm,
  onClose,
}: ConfirmModelUpdateModalProps): React.ReactElement {
  const cancelRef = useRef<HTMLButtonElement>(null);

  const handleConfirmModelUpdate = async () => {
    await onConfirm();
  };

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {'Confirm model update'}
          </AlertDialogHeader>
          <AlertDialogBody>
            <Stack columnGap={2}>
              <Text>
                A model with this name already exists. Do you want to replace
                it?
              </Text>
            </Stack>
          </AlertDialogBody>

          <AlertDialogFooter>
            <Button colorScheme={'gray'} ref={cancelRef} onClick={onClose}>
              Cancel
            </Button>
            <Button
              colorScheme="brand"
              onClick={handleConfirmModelUpdate}
              ml={3}
              variant={'outline'}
            >
              Confirm
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}
